import { useCallback, useEffect, useState } from 'react';
import { fetchBanksCatalog } from '../services/banksCatalog';

export function useBanksCatalog({ enabled = true } = {}) {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const loadBanks = useCallback(async () => {
    if (!enabled) {
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const catalog = await fetchBanksCatalog();
      setBanks(catalog);
    } catch (loadError) {
      console.error('Error cargando bancos:', loadError);
      setBanks([]);
      setError('Error al cargar la lista de bancos');
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) {
      loadBanks();
    } else {
      setBanks([]);
      setLoading(false);
      setError(null);
    }
  }, [enabled, loadBanks]);

  return {
    banks,
    loading,
    error,
    retry: loadBanks,
  };
}
